import React from "react";
import styles from "../Styles/Privacy.css";

export const Privacy = () => {
  return (
    <div className="mainDiv-privacy">
      <h1>Privacy Policy for IdeaKart</h1>
      <p>
        At www.IdeaKart.com we consider the privacy of our visitors to be
        extremely important. This policy document describe in detail the type of
        personal information is
        <br />
        collect and record by www.IdeaKart.com and how to use it.
      </p>
      <h4>Log Files</h4>
      <p>
        Like many other web site,www.IdeaKart.com makes use of log files. These
        files merely logs visitors to the site -usually a standard procedure for
        hosting companies and a<br />
        part of hosting service's analytics. The information inside the log file
        include internet protocol (IP) addresses, browser type, Internet Service
        Provider(ISP), Date/time
        <br />
        stamp, referring/exit pages, and possibly the number of click. this
        information is used tp analyze trends, administer the site, track user's
        movement around the site, and
        <br />
        gather demographic information. IP addresses, and other such information
        are not linked to any information that is personally identify.
      </p>
      <h4>Cookies and Web Beacons</h4>
      <p>
        www.ideakart.com uses cookies to store information about visitor's
        preference, to record user-specific information on which pages the site
        visitor accesses or visits, and to
        <br />
        personalize or customize our web page content based upon
        visitors'browers type
      </p>
      <h4>DoubleClick DART Cookie</h4>
      <p>
        → Google, as a third party vendor, uses cookies to serve ads on
        www.ideakart.com.
        <br /> → Google's use of the DART cookie enables it to serve ads to our
        site's visitors based upon their visit to www.ideakart.com and other
        sites on the Internet.
        <br /> → Users may opt out of the use of the DART cookie content network
        privacy policy at the following URL -
        http://www.google.com/privacy_ads.html
      </p>
      <h4>Our Advertising Partners</h4>
      <p>
        Some of our advertising partners may use cookies and web beacons on our
        site. Our advertising partners include .......
        <br />
        Google
        <br />
        Amazon
        <br />
        You may consult this listing to find the privacy policy for each of the
        advertising partners of www.ideakart.com.
        <br />
        <br />
        These third-party ad servers or ad networks use technology in their
        respective  on www.ideakart.com and
        which are sent directly to your browser. They automatically receive your
        IP address when this occurs. Other technologies (such as cookies,
        JavaScript, or Web Beacons) may also be used by our site's third-party
        ad networks to measure the effectiveness of their advertising campaigns
        and/or to personalize the advertising content that you see on the site.
        <br />
        <br />
        www.ideakart.com has no access to or control over these cookies that are
        used by third-party advertisers.
      </p>
      <h4>Third Party Privacy Policies</h4>
      <p>
        You should consult the respective privacy policies of these third-party
        ad servers for more detailed information
        for instructions about how to opt-out of certain practices.
        www.ideakart.com's privacy policy does not apply to, and we cannot
        control the activities of, such other advertisers or web sites.
        <br />
        <br />
        If you wish to disable cookies, you may do so through your individual
        browser options. More detailed information about cookie management with
        specific web browsers can be found at the browsers' respective websites.
      </p>
      <h4>Children's Information</h4>
      <p>
        We believe it is important to provide added protection for children
        online. We encourage parents and guardians to spend time online with
        their children to observe,
        <br /> participate in and/or monitor and guide their online activity.
        www.ideakart.com does not knowingly collect any personally identifiable
        information from children under the age
        <br /> of 13. If a parent or guardian believes that www.ideakart.com has
        in its database the personally-identifiable information of a child under
        the age of 13, please contact us
        <br /> immediately (using the contact in the first paragraph) and we
        will use our best efforts to promptly remove such information from our
        records.
      </p>
      <h4>Online Privacy Policy Only</h4>
      <p>
        This privacy policy applies only to our online activities and is valid
        for visitors to our website and regarding information shared and/or
        collected there. This policy does not<br/> apply to any information collected
        offline or via channels other than this website.
      </p>
      <h4>Consent</h4>
      <p>By using our website, you hereby consent to our privacy policy and agree to its terms.</p>
    </div>
  );
};